__turbopack_context__.v({
  "marquee": "styles-module-scss-module__a9sRqW__marquee",
  "marqueeContent": "styles-module-scss-module__a9sRqW__marqueeContent",
  "paused": "styles-module-scss-module__a9sRqW__paused",
  "scroll": "styles-module-scss-module__a9sRqW__scroll",
});
